const DEFAULT_GGMAP_REGION = 'AU';
const DEFAULT_SEPARATOR = '.';
const DEFAULT_THE_COMMA = ',';

// Setting both minimumFractionDigits and maximumFractionDigits to 0 to fix the issue maximumFractionDigits is out of range error in Safari 14
/** @deprecated please use formatNumber from src/general/helpers/formatNumber.ts */
export function formatNumber(value, separator = DEFAULT_SEPARATOR, code = 'en-US', options = {}) {
  return (+`${value}`)
    .toLocaleString(code, {
      ...options,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })
    .replace(/,/g, separator);
}

export function formatNumberComma(value, separator = DEFAULT_THE_COMMA, code = 'en-US', options = {}) {
  return (+`${value}`)
    .toLocaleString(code, {
      ...options,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })
    .replace(/,/g, separator);
}

export function smartParseFloat(n, fractionDigits = 2) {
  return parseFloat(parseFloat(n).toFixed(fractionDigits));
}

// https://superuser.com/questions/871404/what-would-be-the-the-mathematical-equivalent-of-this-excel-formula-pmt
export function calcP(rate, presentValue, years) {
  const APR = rate / 100;
  const Pv = presentValue;
  const Rw = APR / 52;
  const nw = years * 52;
  const Rm = APR / 12;
  const nm = years * 12;

  const perWeek = (Pv * Rw) / (1 - 1 / (1 + Rw) ** nw);

  const perMth = (Pv * Rm) / (1 - 1 / (1 + Rm) ** nm);

  return {
    perMonth: perMth,
    perWk: perWeek,
  };
}

export const getProductImgUrl = (sku) => {
  // Tactical fix, images API must be used to retrieve the Product card image
  // However this will need broader refactoring as, ideally, this API call needs to be done once for all cars in the catalogue
  // Talk to Flo if not sure
  if (sku) {
    if (sku.startsWith('0')) {
      sku = sku.substring(1);
    }
  }
  return `https://images.carma.com.au/${sku}/360doorsclosed/${sku}_XC_02.jpg`;
};

export const getGGMapRegion = () => process.env.REACT_APP_REGION || DEFAULT_GGMAP_REGION;

export const getRegexForm = {
  phoneRegex: new RegExp(
    /^(?=.*)((?:61) ?(?:\((?=.*\)))?([2-47-8])\)?|(?:\((?=.*\)))?(0[1-9]|13|18)\)?) ?-?(?=.*)((\d{8}$)|(00 ?-?\d{8}$))/,
  ),
  nameRegex: new RegExp(/^[A-Za-z ,.'-]*$/),
  postalCodeRegex: new RegExp(/^[0-9]{4}$/),
  postalCodeSetLocationPopupRegex: new RegExp(/^[0-9]{3,}$/),
  driversLicenseRegex: new RegExp(/^[a-zA-Z0-9]{6,11}$/),
  charactersWithSpaceRegex: new RegExp(/^[A-Za-z\s]*$/),
};
